package world.phantasmal.webui.widgets

private var id = 0

fun uniqueId() = "pw-id-${id++}"
